import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Inline archival copy — muted, full-width readable, never floating.
 * Use under headings or CTAs instead of tooltips or coaching popovers.
 */
export function ArchiveHelperText({ children, className, id }) {
  return (
    <p
      id={id}
      className={cn(
        'text-[0.9375rem] leading-relaxed text-muted-foreground sm:max-w-2xl',
        className
      )}
    >
      {children}
    </p>
  );
}
